import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import RadioGroupField from 'components/RadioGroupField';

import './SecurityScopeQuestion.styles.scss';

type SecurityScopeQuestionProps = {
  className?: string;
};

const SecurityScopeQuestion: React.FC<SecurityScopeQuestionProps> = (props) => {
  const { className } = props;

  const classes = classNames('security-scope-question', className);

  const { t } = useTranslation();

  const options = useMemo(
    () => [
      { value: 'true', label: t('applyToAllFiles') },
      { value: 'false', label: t('applyToFutureFilesOnly') },
    ],
    [t],
  );

  return (
    <div className={classes}>
      <p>{t('securityScopeQuestion')}</p>
      <RadioGroupField name="applyOnExistingFiles" options={options} required />
    </div>
  );
};

export default SecurityScopeQuestion;
